import React, { useEffect } from "react";
import Grid from "../../assets/Grid.png";
import Navbar from "../Navbar";
import Footer from "../Footer";

const Deleteaccount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="full-container">
        <section className="privacy-section">
          <p className="privacy-subtitle" style={{ fontSize: "24px" }}>
            Packky
          </p>
          <h2 className="privacy-title1" style={{ fontSize: "24px" }}>
            Delete Account
          </h2>
        </section>
        <div
          className="privacy-container-fluid"
          style={{
            backgroundColor: "#ffeef8",
            backgroundImage: `url(${Grid})`,
          }}
        >
          <div className="privacy-card bg-white">
            <h2 className="title"> Delete Your Account — Packky App</h2>
            <div className="mt-4">
              <div className="d-flex mb-3">
                If you would like to request the deletion of your Packky account
                and all associated personal data, please follow the steps below:
              </div>
              <div className="d-flex mb-2">
                <h6 className="privacy-title" style={{ color: " #525252" }}>
                  {" "}
                  How to Request Account Deletion
                </h6>
              </div>
              <ul className="terms-list">
                <li className="terms-list-item">
                  Send an email to support@packky.com from your registered email
                  address.
                </li>
                <li className="terms-list-item">
                  Mention your registered username and request for account
                  deletion.
                </li>
                <li className="terms-list-item">
                  Our support team will verify your details and process the
                  deletion.
                </li>
              </ul>

              <div className="d-flex mb-2">
                <h6 className="privacy-title" style={{ color: " #525252" }}>
                  {" "}
                  What Data Will Be Deleted
                </h6>
              </div>
              <ul className="terms-list">
                <li className="terms-list-item">
                  Your account information (name, phone number, email address)
                </li>
                <li className="terms-list-item">
                  Your profile and login credentials
                </li>
                <li className="terms-list-item">
                  Delivery and activity history
                </li>
              </ul>

              <div className="d-flex mb-2">
                <h6 className="privacy-title" style={{ color: " #525252" }}>
                  {" "}
                  Data Retention Policy
                </h6>
              </div>
              <ul className="terms-list">
                <li className="terms-list-item">
                  Some information, such as financial transactions or tax
                  records, may be retained for up to 180 days after account
                  deletion, as required by applicable laws.
                </li>
                <li className="terms-list-item">
                  After the retention period, this data will also be permanently
                  deleted.
                </li>
              </ul>
              <div className="d-flex mb-2">
                <h6 className="privacy-title" style={{ color: " #525252" }}>
                  {" "}
                  Processing Timeline
                </h6>
              </div>
              <ul className="terms-list">
                <li className="terms-list-item">
                  Your account and associated data will be deleted within 7
                  business days after we receive your deletion request.
                </li>
              </ul>
              <div className="d-flex mb-1">
                <h6 className="privacy-title" style={{ color: " #525252" }}>
                  {" "}
                  Need Help?
                </h6>
            </div>
            <div> For any questions or concerns, please contact us at:</div>
            <p className="card-text mb-1">
          📧 <a href="mailto:support@packky.com">support@packky.com</a>
        </p>
        <p className="card-text">
          📞 <a href="tel:+919958853167">+91-9958853167</a>
        </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Deleteaccount;
